<h2 mat-dialog-title>{{ 'dialog.h2.title' | translate }}</h2>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-content>
  <div fxLayout="column" fxLayoutAlign="space-between start">
    <div>
      <h3>{{ 'dialog.div.content.h3' | translate }}</h3>
      <p
        id="sabadellConditionsLink"
        [innerHtml]="
          'dialog.div.content.p1'
            | translate
              : {
                  url: 'https://www.sabadellconsumeronline.com/SabadellConsumer/html/condiciones.htm',
                  target: '_blank'
                }
        "
      ></p>
      <p [innerHtml]="'dialog.div.content.p2' | translate"></p>
      <p [innerHtml]="'dialog.div.content.p3' | translate"></p>
      <p *ngIf="data.nif" translate [translateParams]="{ nombre: data.username, nif: data.nif ? data.nif : '' }">
        dialog.div.content.p4
      </p>
    </div>
    <mat-checkbox
      id="checkCondicionesCondicionesDialog"
      color="primary"
      [checked]="checked"
      (change)="checked = !checked"
      aria-label="Aceptar condiciones"
      name="checkCondiciones"
    >
      <span>{{ 'dialog.div.content.checkbox' | translate }} </span>
    </mat-checkbox>
  </div>
</mat-dialog-content>
<mat-divider class="dialog__divider--bottom"></mat-divider>
<mat-dialog-actions align="end">
  <button
    id="acceptButtonCondicionesDialog"
    mat-flat-button
    color="accent"
    [disabled]="!checked"
    name="buttonContinuar"
    (click)="aceptarCondiciones()"
    [mat-dialog-close]="true"
  >
    <span>{{ 'dialog.actions.button' | translate }}</span>
  </button>
</mat-dialog-actions>
